import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { FREE_OF_CHARGE_RULE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import FreeOfChargeRuleBasicInformationResource from './resources/FreeOfChargeRuleBasicInformationResource';
import {
  clearFreeOfChargeRule,
  getFreeOfChargeRule,
} from '../../../../actions/sales/FreeOfChargeRule';

export const FreeOfChargeRule = ({
  breadcrumbs,
  dispatchClearFreeOfChargeRule,
  dispatchGetFreeOfChargeRule,
  match: {
    params: { id: freeOfChargeRuleId },
  },
  loading,
  freeOfChargeRule,
}) => {
  useLayoutEffect(() => {
    dispatchGetFreeOfChargeRule({ freeOfChargeRuleId });

    return () => dispatchClearFreeOfChargeRule();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (freeOfChargeRule.isEmpty())
    content = <NoDataResource returnPage={FREE_OF_CHARGE_RULE_PATH} />;
  else {
    const freeOfChargeRuleJson = freeOfChargeRule.toJS();
    content = (
      <>
        <div className="row mb-4">
          <div className="col-md-8">
            <h3>Información Básica</h3>
            <FreeOfChargeRuleBasicInformationResource
              freeOfChargeRule={freeOfChargeRuleJson}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Regla Para Servicio a Título Gratuito"
      content={content}
    />
  );
};

FreeOfChargeRule.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearFreeOfChargeRule: PropTypes.func.isRequired,
  dispatchGetFreeOfChargeRule: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  freeOfChargeRule: PropTypes.instanceOf(Immutable.Map).isRequired,
};

FreeOfChargeRule.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearFreeOfChargeRule: clearFreeOfChargeRule,
  dispatchGetFreeOfChargeRule: getFreeOfChargeRule,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reglas para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_RULE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  freeOfChargeRule: SalesUnit.FreeOfChargeRule.getIn(['current', 'content']),
  loading: !SalesUnit.FreeOfChargeRule.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeOfChargeRule);
